import { RoleEnum } from '../enums/RoleEnum';

export type StaticAppCatalogEntry = {
  id: string;
  name: string;
  param: string;
  navTo?: string;
  description: string;
  detail_description?: string;
  imageUrl: string;
  detail_image?: string;
  detail_areas?: string[];
  color: string;
  active: boolean;
  permissions: RoleEnum[];
};

const STATIC_APPS_CATALOG: StaticAppCatalogEntry[] = [
  {
    id: 'Vycfuq16hnwpBi7Dqt0Z',
    name: 'Brain Game',
    param: 'braingame',
    navTo: 'braingame/game-select',
    description: 'Exercise your mind by managing time, strategy, and knowledge.',
    detail_description:
      "By practicing your ability to juggle multiple demands while under a time constraint you are exercising areas of the brain that tend to both be most helpful for older adults and have the largest impact on daily life.",
    imageUrl: 'assets/apps/braingame/icon.png',
    detail_image: 'assets/apps/braingame/detail.png',
    detail_areas: ['Executive Function', 'Speed of Processing'],
    color: '#379370',
    active: true,
    permissions: [RoleEnum.Admin, RoleEnum.Subscriber, RoleEnum.Client, RoleEnum.Staff],
  },
  {
    id: '6nloZCdMFdxu92grY4HW',
    name: 'Clubhouse',
    param: 'clubhouse',
    navTo: 'clubhouse/meeting/select',
    description: 'Get brain smart and support from others.',
    detail_description:
      "Socializing is thought to improve performance of an area of the brain that shows decline with disease states, such as Alzheimer’s and dementia. Clubhouse is a social learning experience that combines learning about brain health, socializing, and social accountability to ensure that you stay up to date and on track with your brain health program.",
    imageUrl: 'assets/apps/clubhouse/icon.png',
    detail_image: 'assets/apps/clubhouse/detail.png',
    detail_areas: ['Global Cognition', 'Crystallized Intelligence'],
    color: '#3aa2b3',
    active: true,
    permissions: [RoleEnum.Admin, RoleEnum.Subscriber, RoleEnum.Client, RoleEnum.Staff],
  },
  {
    id: 'kKhDMhJqbsoJOQxNbzHF',
    name: 'Happy Place',
    param: 'happyplace',
    navTo: 'happy-place/home',
    description: 'Say goodbye to stress',
    detail_description:
      "Stress can be damaging to many things, including brain health and quality of life. Happy Place is designed to reduce stress by increasing control over physical reactions to life’s challenges.",
    imageUrl: 'assets/apps/happyplace/icon.png',
    detail_image: 'assets/apps/happyplace/detail.png',
    detail_areas: ['Executive Function', 'Short Term Memory'],
    color: '#35868c',
    active: true,
    permissions: [RoleEnum.Subscriber, RoleEnum.Admin, RoleEnum.Staff, RoleEnum.Client],
  },
  {
    id: '1794f39b-985f-4e09-b84f-09e5bc6fd263',
    name: 'Outside Training',
    param: 'outsidetraining',
    // Outside Training is launched via modal (special-cased by name in the UI), not navTo.
    description: 'Tell us about your day and get credit for your activities',
    detail_description:
      'Enter in details about your day and get credit towards your weekly progress score.\n\nSimply enter in what you did for the day like "I woke up, made eggs, went to the mall, walked with some friends, got lunch, and am now starting this app."\n\nand our technology will determine what activities occured during your day and what categories they belong to.\nFeel free to edit what categories are being counted if you believe we are wrong. Finally we will give you credit for your weekly progress.\nYou can enter this information 5 times a week',
    imageUrl: 'assets/apps/outsidetraining/icon.png',
    detail_image: 'assets/apps/outsidetraining/detail.png',
    detail_areas: ['Executive Function', 'Speed of Processing'],
    color: '#5b7a3d',
    active: true,
    permissions: [RoleEnum.Admin, RoleEnum.Subscriber, RoleEnum.Client, RoleEnum.Staff],
  },
  {
    id: 'mus92P4j6AoWwhs6ERKu',
    name: 'Yahootie',
    param: 'yahootie',
    navTo: 'yahootie/game-configuration',
    description: 'Break a physical and mental sweat.',
    detail_description:
      'Appropriate physical exercise has been shown to improve cognition both indirectly, through lowering risk of things like falls, cardiovascular disease, and stress, and directly, through improving the chemical processes and structure of the brain. When done properly, physical exercise can also prime your brain for training. Yahootie expertly combines physical exercises and brain training to maximize impact on your daily life.',
    imageUrl: 'assets/apps/yahootie/icon.png',
    detail_image: 'assets/apps/yahootie/detail.png',
    detail_areas: ['Executive Function', 'Speed of Processing'],
    color: '#32342f',
    active: true,
    permissions: [RoleEnum.Admin, RoleEnum.Subscriber, RoleEnum.Staff, RoleEnum.Client],
  },
];

/**
 * Returns a *fresh* list each call, because downstream services mutate app objects
 * (e.g. compliance %, category, daysSinceLastUse).
 */
export function getStaticAppsCatalog(): StaticAppCatalogEntry[] {
  return STATIC_APPS_CATALOG.map((app) => ({
    ...app,
    permissions: [...app.permissions],
    detail_areas: app.detail_areas ? [...app.detail_areas] : undefined,
  }));
}


